import { baseApi } from 'app/baseApi';
import { baseQuery } from 'app/baseQuery';
import { apiTags } from 'app/store/apiTags';

const basePath = 'mechanicals';

export const mechanicalsApi = baseApi.injectEndpoints({
    reducerPath: 'mechanicalsApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getMechanicalsConfig: builder.query({
            query: ({ clientAccountId, lotId }) => `${basePath}?clientAccountId=${clientAccountId}&lotId=${lotId}`,
            providesTags: [apiTags.MECHANICALS_CONFIG]
        }),
        updateMechanicalRule: builder.mutation({
            query: body => ({
                url: `${basePath}/updateRule`,
                method: "POST",
                body
            }),
            invalidatesTags: [apiTags.MECHANICALS_CONFIG],
        }),
        getMechanicalRuleTypes: builder.query({
            query: () => `${basePath}/ruletypes`,
            providesTags: [apiTags.MECHANICAL_RULE_TYPES]
        }),
        getMechanicalRuleTypesByActivity: builder.query({
            query: (activityId) => `${basePath}/ruletypesByActivity/${activityId}`,
        }),
        addMechanicalRule: builder.mutation({
            query: ({ clientAccountId, lotIds, activityId, vehicleTypeIdsList, calcOnCheckin, ruleOperand, daysToComplete, preferredServiceProviderId, ruleParams, allLots, allPmfLots }) => ({
                url: `${basePath}`,
                method: "POST",
                body: {
                    clientAccountId,
                    lotIds,
                    activityId,
                    vehicleTypeIdsList,
                    calcOnCheckin,
                    ruleOperand,
                    daysToComplete,
                    preferredServiceProviderId,
                    ruleParams,
                    allLots,
                    allPmfLots
                }
            }),
            invalidatesTags: [apiTags.MECHANICALS_CONFIG]
        }),
        updateMechanicalsConfig: builder.mutation({
            query: ({ clientAccountId, lotId, ...params }) => ({
                url: `${basePath}/config`,
                method: "PUT",
                body: {
                    clientAccountId,
                    lotId,
                    ...params
                }
            }),
            invalidatesTags: [apiTags.MECHANICALS_CONFIG]
        }),
        deleteMechanicalsConfig: builder.mutation({
            query: ({ id }) => ({
                url: `${basePath}`,
                method: "DELETE",
                body: {
                    id
                }
            }),
            invalidatesTags: [apiTags.MECHANICALS_CONFIG]
        }),
    }),
});

export const {
    useGetMechanicalsConfigQuery,
    useUpdateMechanicalRuleMutation,
    useGetMechanicalRuleTypesQuery,
    useGetMechanicalRuleTypesByActivityQuery,
    useUpdateMechanicalsConfigMutation,
    useAddMechanicalRuleMutation,
    useDeleteMechanicalsConfigMutation
} = mechanicalsApi;
